import { render, staticRenderFns } from "./RequisitionManagmentTabs.vue?vue&type=template&id=73656ccc&scoped=true"
import script from "./RequisitionManagmentTabs.vue?vue&type=script&lang=js"
export * from "./RequisitionManagmentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73656ccc",
  null
  
)

export default component.exports